import m from "./default-messages.json"

export type Messages = typeof messages

export const messages = {
  source_selection: {
    title: m.select_capture_option,
    camera_permissions_warning: {
      title: m.camera_access_denied,
      instructions_reset: m.update_camera_permissions_or_upload,
      instructions_reload: m.update_camera_permissions_or_upload,
    },
    camera_video: m.take_photo,
    upload_photo: m.upload_from_device,
    switch_camera: m.switch_camera,
    continue_on_desktop: m.continue_on_desktop,
    retry_generating_qr: m.retry_generating_qr,
  },
  tutorial: {
    how_to_take_a_photo: m.how_to_take_a_great_photo,
    good_lighting: m.your_face_should_be_well_lit_from_a_front,
    hair_away_from_face: m.move_hair_back,
    makeup_off: m.remove_extensive_makeup_or_mask,
    glasses_off: m.remove_glasses,
    tip: m.tip,
    take_photo: m.take_photo,
    upload_photo: m.upload,
    next: m.next,
    close: m.close,
  },
  face_live_video: {
    face_displaced: m.place_face_inside_frame,
    face_placement_fixed: m.perfect,
    face_distance_far: m.move_closer,
    face_distance_close: m.move_further_away,
    face_distance_fixed: m.perfect,
    face_angle_deviation: {
      pitch_up: m.raise_your_head,
      pitch_down: m.lower_your_head,
      yaw_left: m.turn_your_head_left,
      yaw_right: m.turn_your_head_right,
      roll_clockwise: m.tilt_your_head_right,
      roll_counter_clockwise: m.tilt_your_head_left,
    },
    face_angle_fixed: m.perfect,
    lighting_insufficient: m.find_brighter_place,
    lighting_excessive: m.find_darker_place,
    lighting_angle_deviation: m.turn_to_light_source,
    lighting_fixed: m.perfect,
    capturing: m.look_at_the_camera,
  },
  face_180_live_video: {
    face_displaced: m.place_face_inside_frame,
    face_placement_fixed: m.perfect,
    face_distance_far: m.move_closer,
    face_distance_close: m.move_further_away,
    face_distance_fixed: m.perfect,
    face_angle_deviation: {
      pitch_up: m.raise_your_head,
      pitch_down: m.lower_your_head,
      yaw_left: m.turn_your_head_left,
      yaw_right: m.turn_your_head_right,
      roll_clockwise: m.tilt_your_head_right,
      roll_counter_clockwise: m.tilt_your_head_left,
    },
    face_angle_fixed: m.perfect,
    lighting_insufficient: m.find_brighter_place,
    lighting_excessive: m.find_darker_place,
    lighting_angle_deviation: m.turn_to_light_source,
    lighting_fixed: m.perfect,
    rotating_left: m.move_your_head_slowly_to_scan_your_skin,
    rotating_right: m.move_your_head_slowly_to_scan_your_skin,
    capturing_front: m.stay_still,
    capturing_left: m.stay_still,
    capturing_right: m.stay_still,
    capturing_done: m.perfect,
  },
  hair_live_video: {
    face_displaced: m.place_face_inside_frame,
    face_placement_fixed: m.perfect,
    face_distance_close: m.move_further_away,
    face_distance_fixed: m.perfect,
    lighting_insufficient: m.find_brighter_place,
    lighting_fixed: m.perfect,
    hair_not_visible: m.make_hair_visible,
    hair_visibility_fixed: m.perfect,
    face_angle_deviation: {
      pitch_up: m.raise_your_head,
      pitch_down: m.lower_your_head,
      yaw_left: m.turn_your_head_left,
      yaw_right: m.turn_your_head_right,
      roll_clockwise: m.tilt_your_head_right,
      roll_counter_clockwise: m.tilt_your_head_left,
    },
    face_angle_fixed: m.perfect,
    capturing: {
      manual: m.make_hair_visible_photo_manual,
      auto: m.make_hair_visible_photo_auto,
    },
  },
  image_quality: {
    face_displaced: {
      title: m.no_face_detected,
      description: m.make_sure_your_face_is_visible,
    },
    face_pitch_angle_deviation: {
      title: m.incorrect_angle,
      description: m.turn_face_to_camera,
    },
    face_roll_angle_deviation: {
      title: m.incorrect_angle,
      description: m.turn_face_to_camera,
    },
    face_yaw_angle_deviation: {
      title: m.incorrect_angle,
      description: m.turn_face_to_camera,
    },
    lighting_insufficient: {
      title: m.poor_lighting,
      description: m.make_sure_your_face_is_well_lit,
    },
    lighting_excessive: {
      title: m.poor_lighting,
      description: m.make_sure_your_face_is_well_lit,
    },
    lighting_angle_deviation: {
      title: m.poor_lighting,
      description: m.make_sure_your_face_is_well_lit,
    },
    quality_noise: {
      title: m.too_much_noise,
      description: m.make_sure_your_face_is_well_lit,
    },
    quality_blur: {
      title: m.image_is_blurry,
      description: m.try_taking_sharper_photo_for_better_results,
    },
    quality_resolution: {
      title: m.low_resolution,
      description: m.upload_a_higher_resolution_photo,
    },
    quality_full_face: {
      title: m.full_face_not_visible,
      description: m.ensure_your_entire_face_is_within_the_frame,
    },
    low_image_quality: {
      title: m.low_image_quality,
      description: m.use_a_better_quality_photo_for_accurate_analysis,
    },
  },
  preview: {
    title: m.well_done,
    retake: m.retake,
    submit: m.submit,
    upload: m.upload,
    image_issue: m.image_issue,
  },
  error: {
    title: m.ooops,
    description: m.video_failed_use_upload,
  },
  companion: {
    invite_title: m.scan_qr_to_take_photo_with_smartphone,
    invite_description: m.results_will_show_here,
    active_title: m.take_selfie_on_smartphone,
    uploading_title: m.uploading,
    uploading_description: m.file_processing_in_progress,
    done_title: m.continue_on_your_desktop,
    done_description: m.close_page_and_continue_on_another_device,
    error_title: m.ooops,
    error_description: m.photo_capture_failed_internal_error,
  },
  license: {
    refresh: m.try_again,
    title: m.oops_something_went_wrong,
    description: m.please_try_again_later_or_contact_support,
  },
  image_size_error: {
    title: m.image_too_large,
    description: m.image_size_exceeded_description,
    upload_smaller: m.upload_smaller_image,
    use_camera: m.use_camera_instead,
  },
  loading: {
    processing_photo: m.processing_photo,
    processing_photo_180: m.processing_photo_180,
    processing_may_take_few_seconds: m.processing_may_take_few_seconds,
  },
}
